module.exports = __webpack_public_path__ + "static/media/logo.689a2bcc.png";